export default function defaultFormatter(value, _unit, suffix) {
  var unit = value !== 1 ? _unit + 's' : _unit;
  return value + ' ' + unit + ' ' + suffix;
}